import { useAtomValue, useSetAtom, atom, useAtom } from "jotai";

export type FilterType = "in-stock" | "sale";

const swatchFilterAtom = atom<FilterType[]>([]);

export const useSwatchFilterType = () => useAtom(swatchFilterAtom);
export const useSetSwatchFilterType = () => useSetAtom(swatchFilterAtom);
export const useSwatchFilterTypeValue = () => useAtomValue(swatchFilterAtom);
